/* eslint camelcase: 0 */
import SslSupportService from '../../blocks/ssl-support-service/ssl-support-service';

export default class BaseUrlHelper {
  /*@ngInject*/
  constructor($q, baseUrlValidator, i18n, fields, confirm, urlHelper, wizardInfo) {
    this.$q = $q;
    this.baseUrlValidator = baseUrlValidator;
    this.i18n = i18n;
    this.fields = fields;
    this.confirm = confirm;
    this.urlHelper = urlHelper;
    this.sslSupportService = new SslSupportService();
    this.wizardInfo = wizardInfo;

    this.VALIDATION_MESSAGES = {
      validating: i18n('Validating configuration parameters'),
      // eslint-disable-next-line camelcase
      checking_availability: i18n('Validating Base URL')
    };
  }

  checkBaseUrl(model) {
    return this.baseUrlValidator.validate(model).
      catch(response => {
        if (response.data && response.data.errors) {
          return this.$q.reject(response);
        } else if (!response.warning &&
                   !this.wizardInfo.forceWarningOnInvalidBaseUrlFlag &&
                   model[this.fields.SERVER_CONNECTOR_MODE_SETTING][this.fields.SECURE_MODE] === this.sslSupportService.TLS_MODE) {
          const errorResponse = {};
          errorResponse.errors = [];
          errorResponse.errors[0] = {};
          errorResponse.errors[0].error_field = this.fields.BASE_URL;
          errorResponse.errors[0].error_description = response.error || response;
          return this.$q.reject(errorResponse);
        } else {
          return response.warning
            ? response
            : {
              warning: this.getBaseUrlWarning(model[this.fields.BASE_URL]),
              baseUrlBackendAccessState: response.baseUrlBackendAccessState || null,
              testEndpointState: response.testEndpointState || null
            };
        }
      });
  }

  getBaseUrlWarning(baseUrl) {
    if (baseUrl.indexOf('https://') !== -1) {
      return this.i18n('The service is not available from your computer by the given Base URL {{baseUrl}}.\n' +
        'Most likely the provided Listen Port or proxy configuration is not correct, or an access is restricted by Firewall.\n' +
        'Also make sure that SSL certificate of Base URL is trusted by your browser.\n' +
        'If the configuration is correct and end-users can access the service by the Base URL, click Continue.\n' +
        'Otherwise, click Cancel and correct the Base URL.', {baseUrl});
    }

    return this.i18n('The service is not available from your computer by the given Base URL {{baseUrl}}.\n' +
      'Most likely the provided Listen Port or proxy configuration is not correct, or an access is restricted by Firewall.\n' +
      'If the configuration is correct and end-users can access the service by the Base URL, click Continue.\n' +
      'Otherwise, click Cancel and correct the Base URL.', {baseUrl});
  }

  fixBaseUrlInconsistency(baseUrl) {
    return this.urlHelper.addProtocolIfNotExist(baseUrl);
  }

  verifyBaseUrl(modelResource) {

    modelResource[this.fields.BASE_URL] = this.fixBaseUrlInconsistency(modelResource[this.fields.BASE_URL]);

    return this.checkBaseUrl(modelResource).then(res => {
      let verificationResult = {};

      if (res && res.warning) {
        verificationResult = this.confirm(
          this.i18n('Base URL is Not Available'),
          res.warning,
          this.i18n('Continue'),
          null, // use default cancel label
          true // set Cancel as default button
        ).
          then(() => (
            {
              isBaseUrlValid: false,
              baseUrlBackendAccessState: res.baseUrlBackendAccessState || null,
              testEndpointState: res.testEndpointState || null
            }
          ));
      }

      return this.$q.when(verificationResult);
    });
  }
}



// WEBPACK FOOTER //
// ./src/blocks/base-url/base-url__helper.js